module.exports = __webpack_public_path__ + "img/mietendeckel.c0fd4608.png";